import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import router from './router/'
import store from "./store/"
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/common.css'
import './assets/css/normalize.css'
import './assets/css/theme.less'
import BaiduMap from 'vue-baidu-map'
import VueLazyload from "vue-lazyload"
import Constant from "./common/Constant"
import './utils/dayjs'

import parameterServer from './services/parameterServer'

// Vue.use(BaiduMap, {
//   ak: Constant.BAIDU_AK
// })
Vue.use(VueLazyload, {
  loading: Constant.DEFAULT_HOUSE
})
Vue.use(ElementUI);
Vue.config.productionTip = false

// 动态获取百度地图AK并初始化
async function initBaiduMap() {
  try {
    // 从接口获取百度AK
    const response = await parameterServer.getMapProperties();
    console.log('response', response)
    const baiduAk = response.data?.pcBaidu || Constant.BAIDU_AK; // 如果接口返回为空，使用默认AK

    // 动态导入并初始化百度地图
    const BaiduMap = (await import('vue-baidu-map')).default;
    Vue.use(BaiduMap, {
      ak: baiduAk
    });
  } catch (error) {
    // 获取失败时使用默认AK
    const BaiduMap = (await import('vue-baidu-map')).default;
    Vue.use(BaiduMap, {
      ak: Constant.BAIDU_AK
    });
  }
}

// 先初始化百度地图，再创建Vue实例
initBaiduMap().then(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
});

// new Vue({
//   router,
//   store,
//   render: h => h(App),
// }).$mount('#app')
